export default __webpack_public_path__ + "static/media/teacher-blue.3f733509.svg";